import { render, staticRenderFns } from "./LicensingKanbanCard.vue?vue&type=template&id=7f34bf72&scoped=true&"
import script from "./LicensingKanbanCard.vue?vue&type=script&lang=js&"
export * from "./LicensingKanbanCard.vue?vue&type=script&lang=js&"
import style0 from "./LicensingKanbanCard.vue?vue&type=style&index=0&id=7f34bf72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f34bf72",
  null
  
)

export default component.exports